import { IMAGES } from "@/lib/brand";
import { useReveal } from "@/lib/useReveal";

// 3 unique editorial images — none of these appear in any other section.
// First image has a baked-in black border in the PNG → use `crop` flag to scale it slightly
// and let the cell's overflow clip the dark edges, so the photo blends cleanly into the cream page.
const ITEMS = [
  {
    src: IMAGES.galleryGlowBack,
    alt: "Spate cu bronz natural uniform",
    span: "lg:col-span-7 lg:row-span-2",
    crop: true,
  },
  {
    src: IMAGES.galleryLegsDetail,
    alt: "Detaliu picioare cu nuanță bronz auriu",
    span: "lg:col-span-5",
  },
  {
    src: IMAGES.galleryHandShoulder,
    alt: "Mână pe umăr — bronz uniform editorial",
    span: "lg:col-span-5",
  },
];

export default function Gallery() {
  const r = useReveal();
  return (
    <section
      id="galerie"
      data-testid="gallery-section"
      className="py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div ref={r.ref} className={`mb-14 max-w-2xl ${r.className}`}>
          <div className="section-label mb-4">Galerie</div>
          <h2
            data-testid="gallery-title"
            className="font-serif text-4xl sm:text-5xl tracking-tight text-[#3B2A22] leading-[1.05]"
          >
            Inspirație pentru <em className="italic text-[#B88746]">bronzul tău</em>
          </h2>
          <p className="mt-4 text-[#3B2A22]/70">
            Descoperă aspectul natural și luminos al unui spray tan profesional. Nuanțe
            echilibrate, aplicare uniformă și un bronz adaptat fiecărui tip de piele.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 auto-rows-[320px] sm:auto-rows-[380px] lg:auto-rows-[400px]">
          {ITEMS.map((img, i) => (
            <GalleryCell key={i} item={img} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function GalleryCell({ item, index }) {
  const r = useReveal();
  return (
    <div
      ref={r.ref}
      className={`bento-cell ${item.span} ${r.className}`}
      style={{ transitionDelay: `${index * 70}ms` }}
      data-testid={`gallery-item-${index}`}
    >
      <img
        src={item.src}
        alt={item.alt}
        className={`w-full h-full object-cover ${item.crop ? "crop-borders" : ""}`}
      />
    </div>
  );
}
